module.exports = __webpack_public_path__ + "04_glasses_red.ac59a856.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer4/04_glasses_red.png
// module id = 1a9t
// module chunks = 0